// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2k4dP","footer":"ModalError_footer__gDzTm"};